module.exports = __webpack_public_path__ + "img/Number=45.a1ac247b.png";